import "bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/Auth/Login.js";
import Register from "./pages/Auth/Register.js";
import Home from "./pages/Home.js";
import Welcome from "./pages/welcome.js";
import Category from "./pages/Activities/Category.js";
import AdminNavbar from "./components/layout/AdminNavbar.js";
import SupervisorNavbar from "./components/layout/SupervisorNavbar.js";
import StudentNavbar from "./components/layout/StudentNavbar.js";
import NoOneNavbar from "./components/layout/NoOneNavbar.js";

import Profile from "./pages/UserProfile/Profile.js";

import Sports from "./pages/Activities/Sports.js";
import Academic from "./pages/Activities/Academic.js";
import Entertainment from "./pages/Activities/Entertainment.js";
import Competitions from "./pages/Activities/Competitions.js";

import ActivityDetails from "./pages/Activities/ActivityDetails.js";
import EditActivityAdmin from "./pages/Activities/EditActivityAdmin.js";

import AddActivity from "./pages/Activities/AddActivity.js";

import Participants from "./pages/Activities/Participants.js";
import MyActivities from "./pages/Activities/MyActivity.js";

import StudentDashboard from "./pages/Dashboard/StudentDashboard.js";
import SupervisorDashboard from "./pages/Dashboard/SuperVisorDashboard.js";
import AdminDashboard from "./pages/Dashboard/adminDashboard.js";
import OurTeam from "./pages/OurTeam.js";
import Chatbot from "./pages/ChatBot.js";
import Users from "./pages/Admin/Users.js";
import Requests from "./pages/Admin/Requests.js";
import ViewUserProfile from "./pages/Admin/UserProfileViewAdmin";
import Settings from "./pages/settings.js";

import Notifications from "./components/common/notifications.js";
import EmailVerification from "./pages/Auth/EmailVerification.js";
import InstallPwaPopup from "./components/common/InstallButton.js";
import NotFound from "./pages/Errors/NotFound.js";
import Unauthorized from "./pages/Errors/UnAuthorized.js";

import FootballSchedule from "./components/common/SportsSchedule/FootballSchedule.js";
import BasketballSchedule from "./components/common/SportsSchedule/BasketballSchedule.js";
import VolleyballSchedule from "./components/common/SportsSchedule/VolleyballSchedule.js";
import SupervisorPanelSports from "./components/common/SportsSchedule/SuperVisorSportsPanal.js";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext.js";
import FullPageLoader from "./components/ui/fullPageLoader.js";
import ProtectedRoute from "./security/ProtectedRoute.js";
import PointsHistory from "./pages/UserProfile/Points-history.js";
import ShowPointsHistory from "./pages/Admin/showPointsHistory.js";
import SportsSchedule from "./pages/Activities/Sports_Schedule.js";
import RequestDetailsPage from "./pages/Activities/RequestDetailsPage.jsx";
import ForgotPassword from "./components/ForgotPassword.jsx";
import RequestsManager from "./components/RoleRequestsPage.jsx";
import About from "./components/About.jsx";
import ReportProblem from "./components/FooterComponents/ReportProblem.js";
import LegalPage from "./components/FooterComponents/LegalPage.js";
import ScrollToTop from "./components/ScrollToTop.jsx";
import GymStatus from "./pages/Activities/GymStatus.js";
import AdminBookingHistory from "./pages/Admin/AdminBookingHistory.js";
import MilitaryEducation from "./pages/Activities/MilitaryEducation.js";
import MilitaryManagement from "./pages/Admin/MilitaryManagement.js";
import ForegroundListener from "./components/common/ForegroundListener.jsx";

export const userRoles = {
  student: "STUDENT",
  admin: "ADMIN",
  supervisor: "SUPERVISOR",
};
export const faculties = {
  computerScience: "COMPUTER_SCIENCE",
  medicine: "MEDICINE",
  dentistry: "DENTISTRY",
  pharmacy: "PHARMACY",
  engineering: "ENGINEERING",
  businessAdministration: "BUSINESS_ADMINISTRATION",
  mediaAndAppliedLanguages: "MEDIA_AND_APPLIED_LANGUAGES",
  nursing: "NURSING",
  physiotherapy: "PHYSIOTHERAPY",
  fineArts: "FINE_ARTS",
};
export const sportTypeEnum = {
  football: "Football",
  basketball: "Basketball",
  volleyball: "Volleyball",
};

function App() {
  // const navigate = useNavigate();
  const { loading, user } = useContext(AuthContext);

  if (loading) {
    return <FullPageLoader loadingName="Loading user..." />;
  }
  // if (user?.confirmEmailOTP && !user?.confirmEmail) {
  //   setTimeout(async () => {
  //     navigate("/auth/EmailVerification", { state: { email: user?.email } });
  //   }, 2000);
  // }

  const renderNavbar = () => {
    switch (user?.role) {
      case userRoles.student:
        return <StudentNavbar />;
      case userRoles.supervisor:
        return <SupervisorNavbar />;
      case userRoles.admin:
        return <AdminNavbar />;
      default:
        return <NoOneNavbar />;
    }
  };
  return (
    <>
      {renderNavbar()}
      <ScrollToTop />
        <ForegroundListener />
      <Routes>
        
        <Route path="/" element={<Welcome />} />
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/register" element={<Register />} />
        <Route path="/auth/EmailVerification" element={<EmailVerification />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<LegalPage type="privacy" />} />
        <Route path="/terms" element={<LegalPage type="terms" />} />
        <Route path="/our-team" element={<OurTeam />} />

        {/* ------------------------------------------------- */}
        {/* ------------------------------------------------- */}

        {/* ---------------- Protect Admin Pages-------------------- */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute allowedRoles={[userRoles.admin]}>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute allowedRoles={[userRoles.admin]}>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/requests"
          element={
            <ProtectedRoute allowedRoles={[userRoles.admin]}>
              <Requests />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/view-user-profile/:userId"
          element={
            <ProtectedRoute
              allowedRoles={[userRoles.admin, userRoles.supervisor]}
            >
              <ViewUserProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities/categories/:type/edit"
          element={
            <ProtectedRoute
              allowedRoles={[userRoles.admin, userRoles.supervisor]}
            >
              <EditActivityAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/request-details/:id"
          element={
            <ProtectedRoute allowedRoles={[userRoles.admin]}>
              <RequestDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities/categories/:type/participants/:id"
          element={
            <ProtectedRoute
              allowedRoles={[userRoles.admin, userRoles.supervisor]}
            >
              <Participants />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/profile/showPointsHistory"
          element={
            <ProtectedRoute
              allowedRoles={[
                // userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <ShowPointsHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/show-bookings-history"
          element={
            <ProtectedRoute allowedRoles={[userRoles.admin]}>
              <AdminBookingHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/military-management"
          element={
            <ProtectedRoute allowedRoles={[userRoles.admin]}>
              <MilitaryManagement />
            </ProtectedRoute>
          }
        />

        {/* ------------------------------------------------- */}

        {/* ---------------- Protect (supervisor) Pages-------------------- */}
        <Route
          path="/supervisor-dashboard"
          element={
            <ProtectedRoute allowedRoles={[userRoles.supervisor]}>
              <SupervisorDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities/add"
          element={
            <ProtectedRoute allowedRoles={[userRoles.supervisor]}>
              <AddActivity />
            </ProtectedRoute>
          }
        />

        {/* ------------------------------------------------------------- */}

        {/* ---------------- Protect (student) Pages-------------------- */}

        <Route
          path="/student-dashboard"
          element={
            <ProtectedRoute
              allowedRoles={[userRoles.student, userRoles.supervisor]}
            >
              <StudentDashboard />
            </ProtectedRoute>
          }
        />

        {/* ------------------------------------------------------------- */}

        {/* ---------------- Protect (admin), (supervisor) and (student) Pages-------------------- */}

        <Route
          path="/home"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/settings"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/profile"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/profile/pointsHistory"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <PointsHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities/categories"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <Category />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities/categories/sports-schedule"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <SportsSchedule />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities/categories/gym-status"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <GymStatus />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities/categories/sports"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <Sports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities/categories/academic"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <Academic />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities/categories/entertainment"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <Entertainment />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities/categories/competitions"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <Competitions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities/categories/:id"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <ActivityDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="/activities/my-activities"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <MyActivities />
            </ProtectedRoute>
          }
        />

        <Route
          path="/activities/categories/football-schedule"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <FootballSchedule />
            </ProtectedRoute>
          }
        />

        <Route
          path="/activities/categories/basketball-schedule"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <BasketballSchedule />
            </ProtectedRoute>
          }
        />

        <Route
          path="/activities/categories/volleyball-schedule"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <VolleyballSchedule />
            </ProtectedRoute>
          }
        />

        <Route
          path="/activities/categories/sports-schedule/supervisor"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <SupervisorPanelSports />
            </ProtectedRoute>
          }
        />

        <Route
          path="/user/notifications"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <Notifications />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ReportProblem"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <ReportProblem />
            </ProtectedRoute>
          }
        />

        <Route
          path="/role-requests"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <RequestsManager />
            </ProtectedRoute>
          }
        />

        <Route
          path="/activities/categories/military-education"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <MilitaryEducation />
            </ProtectedRoute>
          }
        />

        <Route
          path="/chatbot"
          element={
            <ProtectedRoute
              allowedRoles={[
                userRoles.student,
                userRoles.supervisor,
                userRoles.admin,
              ]}
            >
              <Chatbot />
            </ProtectedRoute>
          }
        />

        {/* ------------------------------------------------------------- */}

        <Route path="/unauthorized-page" element={<Unauthorized />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <InstallPwaPopup />
    </>
  );
}

// /forgot-password
// /activities/categories/sports/${id}/edit
export default App;

///// متنساش حتة التقييم تتعرض قدام الادمن في صفحة تفاصيل النشاط وبرضو تتتعرض للمشرف نسبة التقييم او متوسط التقييم للنشاط دا فاهمني ؟
